import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";
import * as pageData from "./PageData";

var myVar = null;

const underway = 0;
const promptIncomplete = 1;
const promptMoreTime = 2;

export default class MechanicalReasoning extends Component {
    constructor(props) {
        super(props);
        this.interceptClick = this.interceptClick.bind(this);
        this.optionChange = this.optionChange.bind(this);
        this.handleModalProceed = this.handleModalProceed.bind(this);
        this.handleModalReturn = this.handleModalReturn.bind(this);

        const arr = [];

        for (let i = 0; i < pageData.mechanicalReasoningTestPages; i++) {
            arr.push(pageData.nullOption);
        }

        this.state = {
            memory: arr,
            secondsRemaining: 900,
            completedState: underway
        };
    }

    componentDidMount() {
        this.afterUpdate();

        myVar = setInterval(this.updateTimer.bind(this), 1000);
    }

    componentDidUpdate() {
        this.afterUpdate();
    }

    componentWillUnmount() {
        clearTimeout(myVar);
    }

    afterUpdate() {
        this.props.setInterceptClick(this.interceptClick);
    }

    updateTimer() {
        const secondsRemaining = this.state.secondsRemaining;

        try {
            if (secondsRemaining > 0) {
                this.setState({ secondsRemaining: secondsRemaining - 1 });
            } else {
                clearTimeout(myVar);
                this.props.next({ response: pageData.skipRemaining });
            }
        } catch (e) {
            clearTimeout(myVar);
        }
    }

    optionChange(value) {
        const arr = this.state.memory;

        arr[this.props.content.index] = value;

        this.setState({ memory: arr });
    }

    handleModalProceed() {
  /*      if (this.state.completedState === promptIncomplete) {*/
            /*this.props.next({ response: pageData.skipRemaining });*/
/*            this.props.next({ response: this.state.memory[this.props.content.index] });
        } else {
            this.props.next({ response: this.state.memory[this.props.content.index] });
        }*/

        let response = this.state.memory[this.props.content.index];

        if (response !== pageData.nullOption && response !== this.props.content.answer) {
            response *= -1;
        }

        this.props.next({ response: response });
    }

    handleModalReturn() {
        this.setState({ completedState: underway });
    }

    interceptClick(type) {
        if (type === "next") {
            let response = this.state.memory[this.props.content.index];

            if (response !== pageData.nullOption && response !== this.props.content.answer) {
                response *= -1;
            }

            this.props.next({ response: response });
            return true;
        }
        else if (type === "back") {
            let response = this.state.memory[this.props.content.index];

            if (response == null || response == pageData.nullOption)
            {
                return false;
            }

            if (response !== pageData.nullOption && response !== this.props.content.answer) {
                response *= -1;
            }
            this.props.previous({ response: response });
            return false;
        }
        else if (type === "prev") {
            clearTimeout(myVar);
        }
        else if (type === "end") {
            const count = this.state.memory.reduce((accumulator, currentValue) => accumulator + (currentValue === pageData.nullOption ? 1 : 0), 0);

            if (count === 0) {
                this.setState({ completedState: promptMoreTime });
            } else {
                this.setState({ completedState: promptIncomplete });
            }
        }

        return false;
    }

    render() {
        const p = this.props;
        const optionChange = this.optionChange;
        const handleModalReturn = this.handleModalReturn;
        const handleModalProceed = this.handleModalProceed;

        const progressStyle = {
            width: `${p.content.index * (100 / pageData.mechanicalReasoningTestPages)}%`
        };

        return (
            <div className="test-page-content-inner test-page-mechanical-reasoning">
                <div className="test-content">
                    {renderPractice(p, this.state, optionChange, handleModalReturn, handleModalProceed)}
                </div>
                <div className="progress">
                    <div className="progress-bar progress-bar-striped" role="progressbar" style={progressStyle} aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" />
                </div>
            </div>
        );
    }
}

function renderPractice(props, state, optionChange, handleModalReturn, handleModalProceed) {
    const sourceIndex = props.content.index;
    const src = `/images/mechanical-reasoning/${sourceIndex + 1}.jpg`;
    const time = pageData.secondsToTime(state.secondsRemaining);

    return (
        <div className="test-content-inner">
            <h2 className="question-title">Question</h2>
            <div className="question">
                {props.content.question}
            </div>
            <div className="image">
                <img alt="" src={src} height="300px" />
            </div>
            {renderTimer(time)}
            <h2 className="answer-title">Answer</h2>
            <div className="options">
                {renderOptions(props.content.options, props, state, optionChange)}
            </div>
            {renderIncompleteModal(state, time, handleModalReturn, handleModalProceed)}
        </div>
    );
}

function renderIncompleteModal(state, time, handleModalReturn, handleModalProceed) {
    return (
        <Modal show={(state.completedState > underway)}>
            <Modal.Header>
                <Modal.Title>End Test</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {renderModalMessage(state, time)}
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle="default" onClick={handleModalReturn}>No thanks</Button>
                <Button bsStyle="success" onClick={handleModalProceed}>Yes, I'm sure</Button>
            </Modal.Footer>
        </Modal>
    );
}

function renderModalMessage(state, time) {
    if (state.completedState === promptIncomplete) {
        return (
            <div>Are you certain that you want to end the test without answering all the questions?</div>
        );
    }

    return (
        <div>You still have {time} left. Are you sure you want to end the test?</div>
    );
}

function renderOptions(elems, props, state, optionChange) {
    const sourceIndex = props.content.index;

    return elems.map(function (elem, index) {
        return renderOption(elem, props, state, sourceIndex, index + 1, optionChange);
    });
}

function renderOption(elem, props, state, sourceIndex, optionValue, optionChange) {
    const id = `option${sourceIndex}-${optionValue}`;
    const checked = state.memory[sourceIndex] === optionValue ? "checked" : "";
    const disabled = props.waitingForSpeech ? 'disabled' : '';

    return (
        <div className="inputGroup" key={id}>
            <input id={id} type="radio" name="option" value={optionValue} checked={checked} onChange={() => optionChange(optionValue)} disabled={disabled} />
            <label htmlFor={id}><span><span /></span></label>
            <span className="option-text">{elem.text}</span>
        </div>
    );
}

function renderTimer(time) {
    return (
        <div className="timer">
            <div className="timer-title">Time remaining:</div>
            <div className="timer-value">{time}</div>
        </div>
    );
}
